/* SECOND SPRING — carousel controller.

   One controller for every horizontal card rail on the site. It is a scroll-snap
   scroller first: touch, trackpad, keyboard and screen readers all work with zero JS.
   This file only adds the arrows and the progress bar on top.

   Markup contract:
     [data-ss-carousel]
       [data-ss-track]      the scroller
       [data-ss-prev]       optional
       [data-ss-next]       optional
       [data-ss-progress]   optional, gets a --p custom property from 0 to 1

   Nothing here is required for the content to be reachable, which is the point. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-ss-track]');
    if (!track) return;

    var prev = root.querySelector('[data-ss-prev]');
    var next = root.querySelector('[data-ss-next]');
    var bar = root.querySelector('[data-ss-progress]');

    function step() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      // One card plus the gap, so a click lands on a snap point rather than between two.
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 1 ? track.scrollLeft / max : 0;
      if (bar) bar.style.setProperty('--p', p.toFixed(4));
      // A disabled arrow is honest about there being nothing further that way.
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-ss-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ss-carousel]').forEach(init);
  });
})();
